import { createSlice } from '@reduxjs/toolkit'

export const mediaSlice = createSlice({
  name: 'media',
  initialState: {
    selected: null,
  },
  reducers: {
    setSelected: (state, action) => {
      state.selected = action.payload;
    },

    updateImageData: (state, action) => {
      if (action.payload.subTarget) {
        state.selected[action.payload.target][action.payload.subTarget] = action.payload.value;
      } else {
        state.selected[action.payload.target] = action.payload.value;
      }
    },
  },
})

// Action creators are generated for each case reducer function
export const { setSelected, updateImageData } = mediaSlice.actions

export default mediaSlice.reducer